import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tmp-dashboard',
  templateUrl: './tmp-dashboard.component.html',
  styleUrls: ['./tmp-dashboard.component.scss'],
})
export class TmpDashboardComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
